import {Component, OnInit} from '@angular/core';
import {DebuggingService} from '@wba/services/commons/debugging.service';


@Component({
    selector: 'wba-debugging-menu',
    templateUrl: './debugging-menu.component.html',
    styleUrls: ['./debugging-menu.component.scss'],
    standalone: false
})
export class DebuggingMenuComponent implements OnInit {

  currentAntragFormVersion: number;

  constructor(public debuggingService: DebuggingService) {
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.currentAntragFormVersion = this.debuggingService.loadCurrentAntragVersion();
  }

  updateAntragFormVersion(newVersion: string) {
    this.currentAntragFormVersion = +newVersion;
    this.debuggingService.updateAntragFormVersion(+newVersion);
  }

}
